import { useSelector } from 'react-redux';
import { getIsAnonymized } from './selectors';

export const useIsAnonymized = () => {
  const isAnonymized = useSelector((state) => getIsAnonymized(state));
  return { isAnonymized };
};
